// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c7ea146","641":"c04ea621","732":"903e98db","977":"3cf89b44"}[chunkId] + ".chunk.js";
};